// SectionBorderXl
import React from 'react';
import PropTypes from 'prop-types';

function SectionBorderXl({ ...props }) {
  return (
    <div className={ `common-section-border-xl uk-padding-larger uk-flex uk-flex-wrap uk-background-${ props.bgColor }-gradient uk-box-shadow-medium` }>
      <div className={ `uk-width-1-1 uk-border-small-${ props.borderColor } ` }>
        { props.children }
      </div>
    </div>
  );
}

SectionBorderXl.propTypes = {
  bgColor: PropTypes.string,
  borderColor: PropTypes.string,
  children: PropTypes.node
};

export default SectionBorderXl;


// WEBPACK FOOTER //
// ./src/features/common/SectionBorderXl.js